import { styled, Stack } from '@mui/material';

export const FullHeightWrapper = styled(Stack)(() => ({
  flexGrow: 1,
}));
